import type { PaymentOptions } from '../types'

export function isBookingFullyPaid(paymentOptions: PaymentOptions | null): boolean {
  if (!paymentOptions) {
    return false
  }

  return paymentOptions.paymentMethods.length === 0
}
